import { Stack, Typography } from '@mui/material'
import { InfoBubble } from '~/@ui/info-bubble/InfoBubble'
import ArrowUpNewSvg from '~/@ui/_sharedSvgs/ui/ArrowUpNew.svg?react'
import { useState } from 'react'

type Props = {
  theme?: 'light' | 'dark'
  deposit: number
  earlyWithdraw: number
  bonaship: number
  className?: string
}

export const SummaryPensionValues = ({
  theme = 'dark',
  deposit,
  earlyWithdraw,
  bonaship,
  className = '',
}: Props) => {
  const [isOpen, setIsOpen] = useState(true)

  const lightMode = theme === 'light'

  return (
    <Stack
      className={`p-4 pr-4 ${lightMode ? 'bg-zGrey200' : 'bg-zBlack300'} rounded-4d ${className}`}>
      <Stack className="flex-row gap-1">
        <InfoBubble text="Tu vidíte porovnanie mesačnej renty z nasporenej sumy v Bonashipe oproti odkladaniu hotovosti." />
        <Typography
          className={`text-base font-bold ${lightMode ? 'text-zBlack200' : 'text-zWhite200'}`}>
          Vaša renta z nasporenej sumy
        </Typography>
        <ArrowUpNewSvg
          onClick={() => setIsOpen((prev) => !prev)}
          className={`ml-auto ${isOpen ? 'rotate-0' : 'rotate-180'} cursor-pointer`}
        />
      </Stack>

      {isOpen && (
        <Stack className="pb-2">
          <Stack className="gap-3.5 mt-8">
            <Stack className="gap-1.5">
              <Stack className="flex-row items-center">
                <Typography
                  className={`text-xs font-medium ${lightMode ? 'text-zBlack200' : 'text-zWhite200'} mr-auto`}>
                  Z Bonashipu
                </Typography>
                <Typography
                  className={`text-xs font-black ${lightMode ? 'text-zBlack200' : 'text-zWhite200'} mr-1`}>
                  {`${Math.round(((bonaship || earlyWithdraw) * 0.1) / 12).toLocaleString('sk-SK')} €`}
                </Typography>
                <Typography className="text-2d font-medium text-zGrey400">
                  mesačne
                </Typography>
              </Stack>
              <Stack className="w-full h-3.5 bg-zWhite100 rounded-lg">
                <Stack className="w-full h-3.5 bg-gradient-to-r from-[#fec050] via-[#FBE507] to-[#FBE507] rounded-lg" />
              </Stack>
            </Stack>

            <Stack className="gap-1.5">
              <Stack className="flex-row items-center">
                <Typography
                  className={`text-xs font-medium ${lightMode ? 'text-zBlack200' : 'text-zWhite200'} mr-auto`}>
                  Vklad
                </Typography>
                <Typography
                  className={`text-xs font-black ${lightMode ? 'text-zBlack200' : 'text-zWhite200'} mr-1`}>
                  {`${Math.round((deposit * 0.1) / 12).toLocaleString('sk-SK')} €`}
                </Typography>
                <Typography className="text-2d font-medium text-zGrey400">
                  mesačne
                </Typography>
              </Stack>
              <Stack
                className={`w-full h-3.5 ${lightMode ? 'bg-zWhite100' : 'bg-zGrey300'} rounded-lg`}>
                <Stack className="w-[30%] h-3.5 bg-gradient-to-r from-[#CCD5E0] via-[#E0E5EC] to-[#E0E5EC] rounded-lg" />
              </Stack>
            </Stack>
          </Stack>

          <Typography className="text-xs/[170%] font-medium text-zGrey400 italic mt-3">
            Za predpokladu, že nasporenú sumu ste začali zhodnocovať výnosom 10%
            ročne
          </Typography>
        </Stack>
      )}
    </Stack>
  )
}
